import React, { FC, useState } from 'react';
import { Statistics } from '../../interface/Statistics.interface';
import { useEffectOnce } from 'react-use';
import { StatisticLoader } from './StatisticLoader';
import CountUp from 'react-countup';
import { StatsContainer } from './Statistics.style';

interface WeeklyStatisticsProps {
	statistics: Statistics[];
	loading?: boolean;
}

const WeeklyStatistics: FC<WeeklyStatisticsProps> = ({ statistics, loading }) => {
	if (loading) return <StatisticLoader />;

	return (
		<StatsContainer className="flex justify-between rounded-3xl border bg-white">
			{statistics.map((statistic, i) => {
				return (
					<div className="stat__container text__default" key={i}>
						<img src={statistic.img} alt={statistic.label} className="h-14 w-14 xl:h-auto xl:w-20" />
						<div className=" text__default capitalize text-[#afafaf]">{statistic.label}</div>
						<div style={{ color: statistic.color }} className=" flex flex-row items-baseline gap-1 font-bold">
							<CountUp start={0} end={statistic.value} className="stat__number" />
							<div className="text__default">{statistic.description}</div>
						</div>
					</div>
				);
			})}
		</StatsContainer>
	);
};

export default WeeklyStatistics;
